import React from "react";

const STEP_LABELS = ["Firm Info", "Claim Match"];

function LawFirmProfileSteps({
  step,
  title,
  description,
  children,
  onBack,
  onNext,
  nextLabel = "Continue",
  backLabel = "Back",
  nextDisabled = false,
}) {
  return (
    <div className="min-h-screen lg:w-full bg-cream">
      <div className="mx-auto lg:w-full lg:max-w-[90%] max-w-lg px-4 pt-5 pb-4 lg:px-2 lg:py-10">

        {/* Header */}
        <div className="mb-4">
          {title && (
            <h1 className="font-spectral text-[21px] leading-[1.25] lg:text-3xl text-navy">
              {title}
            </h1>
          )}
          {description && (
            <p className="mt-2 text-xs lg:text-sm text-gray-600">
              {description}
            </p>
          )}
        </div>

        {/* Pill step indicator */}
        <div className="mb-4 flex items-center">
          {STEP_LABELS.map((label, i) => {
            const n = i + 1;
            const isLast = n === STEP_LABELS.length;
            return (
              <React.Fragment key={n}>
                <div className="flex items-center gap-2">
                  <div
                    className={
                      "flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full text-sm font-bold " +
                      (step >= n ? "bg-tan text-ivory" : "bg-gray-200 text-gray-500")
                    }
                  >
                    {n}
                  </div>
                  <span
                    className={
                      "text-xs lg:text-sm font-semibold whitespace-nowrap " +
                      (step >= n ? "text-navy" : "text-gray-400")
                    }
                  >
                    {label}
                  </span>
                </div>
                {!isLast && (
                  <div
                    className={
                      "mx-3 h-[2px] flex-1 " + (step > n ? "bg-tan" : "bg-gray-200")
                    }
                  />
                )}
              </React.Fragment>
            );
          })}
        </div>

        {/* Content — brass-foil bordered card */}
        <div className="rounded-2xl bg-gradient-to-br from-gold via-tan to-goldDark p-[1.5px] shadow-sm">
          <div className="rounded-2xl bg-ivory p-2 lg:p-6">{children}</div>
        </div>

        {/* Footer Buttons */}
        <div className="mt-6 flex text-xs lg:justify-center lg:text-base gap-3">
          {step > 1 && (
            <button
              type="button"
              onClick={onBack}
              className="flex-1 rounded-lg border border-tan bg-ivory px-4 py-3 font-medium text-tan hover:bg-cream"
            >
              &lt;- {backLabel}
            </button>
          )}
          {onNext && (
            <button
              type="button"
              onClick={onNext}
              disabled={nextDisabled}
              className={`flex-1 rounded-lg bg-tan px-4 py-3 font-semibold text-ivory hover:bg-tanDark ${
                nextDisabled ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              {nextLabel} -&gt;
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default LawFirmProfileSteps;
